export default "__VITE_ASSET__5baefd47__"